import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function Comments() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <>
      <fieldset>
        <legend>{t("Comments")}</legend>
        <input
          className="form-control"
          name="comments"
          onChange={onChange}
          value={searchObject.comments || ""}
        />
      </fieldset>
    </>
  );
}
